import * as React from 'react';
import { useConfiguratorContext, StepForm } from '@grandvisionhq/configurator';
import { PupillaryDistanceLink } from '../../../components/PupillaryDistanceLink/PupillaryDistanceLink.js';
import { PrescriptionFormLayoutProvider } from '../../context/PrescriptionFormLayoutContext.js';
import { PrescriptionFormColumnContainer } from '../PrescriptionFormColumn/PrescriptionFormColumnContainer.js';
import { PrescriptionFormLayout } from '../PrescriptionFormLayout/PrescriptionFormLayout.js';
import { PrescriptionFormPupillaryDistanceAlert } from '../PrescriptionFormPupillaryDistanceAlert/PrescriptionFormPupillaryDistanceAlert.js';

const PrescriptionForm = ({ className  })=>{
    const { goToNextStep  } = useConfiguratorContext();
    return /*#__PURE__*/ React.createElement(StepForm, {
        className: className,
        onSubmit: goToNextStep
    }, /*#__PURE__*/ React.createElement(PrescriptionFormLayoutProvider, null, /*#__PURE__*/ React.createElement(PrescriptionFormLayout, {
        components: {
            Column: PrescriptionFormColumnContainer,
            Alert: ()=>/*#__PURE__*/ React.createElement(PrescriptionFormPupillaryDistanceAlert, {
                    className: "prescription-form__alert"
                })
            ,
            PupillaryDistanceLink: ()=>/*#__PURE__*/ React.createElement(PupillaryDistanceLink, {
                    className: "prescription-form__pd-link"
                })
        }
    })));
};

export { PrescriptionForm };
//# sourceMappingURL=PrescriptionForm.js.map
